import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import React from 'react';
import SendDataForm from './SendDataFormContainer';
import { TransitionProps } from '@mui/material/transitions';
import { UserConfirmationForModals } from 'new/components/UserConfirmationForModals';

import s from './ModalNexsetForm.module.scss';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

type Props = {
  id?: number;
  isEditMode?: boolean;
  onDismiss?: (nexset: any) => void;
  onClose?: () => void;
  open: boolean;
};

const handleDialogClick = (event: React.MouseEvent) => {
  event?.stopPropagation();
};

const ModalNexsetForm = (props: Props) => {
  const { id, isEditMode, onDismiss, open } = props;

  const onClose = (event = null, reason = '') => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
    if (props.onClose) {
      setTimeout(() => {
        // Why inside a timeout? To keep the animation working
        props.onClose();
      }, 500);
    }
  };

  const onDismissForm = (nexset: any) => {
    onClose();
    onDismiss?.(nexset);
  };

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={onClose}
        keepMounted={false}
        TransitionComponent={Transition}
        onClick={handleDialogClick}
        className={s.dialogContainerOverride}
      >
        <SendDataForm isModal id={id} isEditMode={isEditMode} onDismiss={onDismissForm} />
      </Dialog>
      <UserConfirmationForModals open={open} onConfirm={() => onDismissForm(null)} />
    </>
  );
};

export default ModalNexsetForm;
